<template>
  <div class="cont_wrap">
    <grid-component type="合同管理系统" />
  </div>
</template>

<script>
import gridComponent from '../../components/gridComponent.vue'
import { getDict } from '@/utils/dict'
export default {
  components: { gridComponent },
  name: 'contIndex',
  created() {
    getDict()
    const flag = this.$store.state.dictOptions
    if (flag && flag.contractStatus.length > 0) {} else {
      getDict()
    }
  }
}
</script>
<style lang="less">
.cont_wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 40px;
}
</style>
